<template>
  <a :href="link" :alt="alt">
    {{ text }}
  </a>
</template>

<script>

export default {
  name: 'nt-menu-item',
  props: {
    text: {
      required: true
    },
    link: {
      default: '/'
    },
    alt: {
      default: ''
    }
  }
}
</script>
